import service from "../../service";
var prefix = process.env.VUE_APP_PREFIX;
var state = {
  token: "",
  isLogin: false,
  isNewer: false
};
var mutations = {
  LOGIN_OUT: function LOGIN_OUT(state, token) {
    localStorage.removeItem(prefix + "authToken");
    localStorage.removeItem(prefix + "refreshToken"); // localStorage.removeItem(prefix+"memberId")

    state.isLogin = false;
  },
  LOGIN_IN: function LOGIN_IN(state) {
    state.isLogin = true;
  },
  SET_NEW_USER: function SET_NEW_USER(state, status) {
    state.isNewer = status;
  }
};
var actions = {
  checkLogin: function checkLogin(_ref) {
    var commit = _ref.commit;
    var refreshToken = localStorage.getItem(prefix + 'refreshToken');
    return new Promise(function (resolve, reject) {
      if (refreshToken) {
        commit('LOGIN_IN');
        resolve(true);
      } else {
        commit("LOGIN_OUT");
        resolve(false);
      }

      resolve();
    });
  },
  login: function login(_ref2) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      commit("LOGIN_IN");
      resolve();
    });
  },
  logout: function logout(_ref3) {
    var commit = _ref3.commit;
    return new Promise(function (resolve, reject) {
      commit("LOGIN_OUT");
      resolve();
    });
  },
  checkNewer: function checkNewer(_ref4) {
    var commit = _ref4.commit;
    return new Promise(function (resolve, reject) {
      service.getNewStatus().then(function (res) {
        // console.log(res)
        commit('SET_NEW_USER', res.result);
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};